import { useEffect, useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { useDebouncedValue } from "@mantine/hooks";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { ActionIcon, TextInput } from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";

const TableSearch = ({
  defaultSearch,
  disabled,
  setHasQuery,
  onSearchChange,
  autofocusSearch,
}) => {
  const lang = useLanguage((s) => s.language);
  const [value, setValue] = useState(defaultSearch || "");
  const [debounced] = useDebouncedValue(value, 600);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleClear = () => {
    setValue("");
  };

  const apiRef = useGridApiContext();

  useEffect(() => {
    if (debounced.length > 0) {
      apiRef.current.setQuickFilterValues(debounced.split(" "));
      setHasQuery?.(true);
      onSearchChange?.(debounced);
    }
    if (debounced.length === 0) {
      apiRef.current.setQuickFilterValues([]);
      setHasQuery?.(false);
      onSearchChange?.(debounced);
    }
  }, [apiRef, debounced, value]);

  return (
    <TextInput
      placeholder={lang.table.toolbar.search_placeholder}
      className="table-search"
      w={250}
      value={value}
      radius={8}
      style={{
        borderTop: 0,
      }}
      styles={{
        input: {
          paddingLeft: 42,
          fontSize: 15,
          borderWidth: 2,
          borderColor: "var(--mantine-color-primary-0)",
        },
      }}
      onChange={handleChange}
      leftSection={
        debounced.length > 0 ? (
          <ActionIcon onClick={handleClear} variant="subtle">
            <IconX size={18} />
          </ActionIcon>
        ) : (
          <IconSearch size={18} />
        )
      }
      disabled={disabled}
      autoFocus={autofocusSearch}
      data-autofocus={autofocusSearch}
      autoComplete="off"
      aria-autocomplete="off"
    />
  );
};

export default TableSearch;
